import { ConfirmedDraftAction } from "app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-types";
import { createAiChatAssistantMessage } from "app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-messages";
import { toDraftQuery } from "app/components/ai-chat-assistant/utils/to-draft-query";
import { actionCreators } from "app/components/ai-chat-assistant/actions";
import { FailUpdateDraft, RequestUpdateDraft } from "app/components/ai-chat-assistant/action-types";

export const createCaseDraftAction:ConfirmedDraftAction = async (
  draft, context: { dispatch, updateMessage, translation }
) => {
  const { updateMessage, translation, dispatch } = context;
  const assistantMessage = createAiChatAssistantMessage();
  const caseDraftParameters = toDraftQuery(draft);
  const caseTypeId = draft?.caseType?.v;

  if (!caseTypeId) {
    return;
  }

  updateMessage(assistantMessage.id, translation.textCreatingDraft);

  await dispatch(
    actionCreators.createCaseDraft(
      caseDraftParameters,
      caseTypeId
    )
  );
};

const extractValidValues = (field: any) => {
  return (field?.values ?? [])
    .filter((item) => item?.v !== undefined && item?.v !== null)
    .map((item) => ({
      value: item.v
    }));
};

const updateFieldProperty = async (dispatch: any, property: string, field: any) => {
  const values = extractValidValues(field);

  if (values.length === 0) {
    return;
  }

  await dispatch(actionCreators.updateCaseDraft(property, values));
};

export const updateCaseDraftAction: ConfirmedDraftAction = async (
  draft,
  context
) => {
  const { dispatch, dataTag } = context;
  const fields = draft?.fields;

  if (!fields || !dataTag) {
    return;
  }

  const field = fields[dataTag];

  if (!field) {
    return;
  }

  dispatch(new RequestUpdateDraft());

  try {
    await updateFieldProperty(dispatch, dataTag, field);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    dispatch(new FailUpdateDraft(message));
  }
};
